import styled from 'styled-components'


const BREAKPOINT_MD = 960

export const Container = styled.main`
  display: flex;
  min-height: 100vh;
  position: relative;

  @media (max-width: ${BREAKPOINT_MD}px) {
    flex-direction: column;
  }
`

export const ContentSection = styled.section`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 2rem;

  @media (max-width: ${BREAKPOINT_MD}px) {
    padding: 1rem;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  margin-top: 60px;

  margin-bottom: 20px;

  img {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
  }
`

export const Title = styled.div`
  p {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
  }
`

export const Description = styled.div`
  p {
    font-size: 15px;
    margin-bottom: 20px;
    text-align: center;
  }
`

export const ImageSection = styled.section`
  flex: 1;
  position: relative;

  @media (max-width: ${BREAKPOINT_MD}px) {
    height: 300px;
  }
`

export const MedicalRequestFormContainer = styled.div`
  width: 100%;
  max-width: 400px;
`

export const MedicalRequestExampleContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const MedicalRequestExampleBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  @media (min-width: ${BREAKPOINT_MD}px) {
    position: fixed;
    right: 0;
    top: 0;
    width: 50vw;
    height: 100vh;
  }
`

export const ChatHelper = styled.div`
  position: fixed;
  bottom: 12px;
  right: 90px;
  z-index: 10;
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;

  display: flex;
  align-items: flex-end;
  flex-direction: column;
  text-align: right;

  &:hover {
    transform: translateY(-2px);
  }

  strong {
    color: #1F35B5;
    margin-bottom: 4px;
  }

  p {
    color: #1F35B5;
    font-size: 15px;
    line-height: 20px;
    margin: 0;
  }

  svg {
    color: #1F35B5;
    margin-top: 4px;
  }

  @media (max-width: ${BREAKPOINT_MD}px) {
    right: 16px;
    bottom: 16px;
  }
`

interface AlertContainerProps {
  type: 'success' | 'error'
}

export const AlertContainer = styled.div<AlertContainerProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  border-radius: 10px;
  background-color: ${({ type }) => type === 'success' ? '#E7FFE5' : '#ffdfd4'};
  color: ${({ type }) => type === 'success' ?'#4AC326' : '#FC4949'};
  width: 100%;
`

